/* @flow */
import classesDefaultsFragment from 'groups/fragments/classesDefaultsFragment.gql';
import gql from 'graphql-tag';

export default gql`
  ${classesDefaultsFragment}
  query LoadAllGroups {
    me {
      id
      uuid
      classes {
        ...classesDefaults
      }
    }
  }
`;
